module.exports = __webpack_public_path__ + "img/ico_option_plus.c7c097be.svg";